var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearVideoButton",on:{"click":_vm.click}},[_c('div',{staticClass:"icon"},[_c('iconfont',{staticClass:"normal",attrs:{"name":"#icon12-12shanchu"}}),_c('iconfont',{staticClass:"hover",attrs:{"name":"#icon12-12shanchujiaohu"}})],1),_c('div',[_vm._v("清空列表")])])
}
var staticRenderFns = []

export { render, staticRenderFns }